// CouchDB user role strings used across the application.
// These are the raw role values stored in user documents and checked by agave's permission middleware.
const UserRole = {
  Admin: '_admin',
  Planner: 'userRole:planner',
  Operator: 'userRole:operator',
  FP: 'userRole:fp',
  Retailer: 'userRole:pharmacyUser',
  LeadUser: 'no-database-user',
  Sales: 'userRole:sales',
  SettingRoles: ['settings', 'settings:users'],
  National: 'userRole:psm-national',
  State: 'userRole:psm-state',
  Vendor: 'userRole:psm-vendor',
  Carrier: 'userRole:psm-carrier',
  Driver: 'userRole:psm-driver',
  Facility: 'userRole:psm-facility',
  DistributionManager: 'userRole:psm-distribution-manager',
  UploadShipments: 'uploadShipments',
  Warehouse: 'orders:warehouse',
  RoutePlanningEdit: 'routePlanning:edit'
}

module.exports = UserRole
